import { render } from "./WorkflowList.vue?vue&type=template&id=f99ccde4&ts=true"
import script from "./WorkflowList.vue?vue&type=script&lang=ts"
export * from "./WorkflowList.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__